module.exports = __webpack_public_path__ + "media/photo/comminutions_services-73905518.png";